import * as React from 'react';
import injectSheet from 'react-jss';
import {
  ErrorMessages,
  MapFieldToErrorMessage,
} from '../../constants/errorConstants';
import MobileDetect from '../../utils/mobileDetect';

const styleSheet = (theme: any) => ({
  error: {
    ...theme.error,
    opacity: 0,
    display: MobileDetect.phone() ? 'none' : 'block',
    '@media (max-width: 900px)': {
      paddingLeft: '10px',
    },
  },
});

interface ClassProp {
  error: string;
}

interface ErrorProps {
  theme?: any;
  classes?: ClassProp | any;
  show?: boolean;
  fieldId: string;
}

const Error: React.FC<ErrorProps> = (props: ErrorProps) => {
  const { classes, show, fieldId } = props;
  // prevents error spacing on mobile //
  let errorDisplay;
  if (MobileDetect.phone()) {
    errorDisplay = 'none';
    if (show) errorDisplay = 'block';
  } else {
    errorDisplay = 'block';
  }

  const mapFieldToFieldError = (id: string) => {
    return `${ErrorMessages.FIELD_ERROR} ${MapFieldToErrorMessage[id] || id}`;
  };
  return (
    <div
      className={classes.error}
      style={{
        opacity: show ? 1 : 0,
        display: errorDisplay,
      }}
    >
      {mapFieldToFieldError(fieldId)}
    </div>
  );
};

export default injectSheet(styleSheet)(Error);
